<template>
  <div class="fixed-0 mx-a flex center">
    <base-dialog-root default-open @update:open="$emit('resolve')">
      <base-dialog-overlay
        class="vf-zqqinx"
        data-test-id="vf-modal-backdrop"
      />
      <vf-dialog-content
        class="vf-645j8i"
        :class="[
          classContent,
          {
            'bg-white': !variant,
            'bg-white bg-op-90': variant === 'light',
            'bg-brand-8 bg-op-70': variant === 'brand',
            'bg-grey-20 bg-op-70 c-grey-90': variant === 'dark',
          },
        ]"
        :disable-outside-interaction
        :style="[styleContent, sizes[_size]]"
      >
        <slot />
      </vf-dialog-content>
    </base-dialog-root>
  </div>
</template>

<script lang="ts" setup>
import type { Props } from '#brands/components/vf/modal/Modal.vue'

const { size = { lg: 'lg', sm: 'sm' } } = defineProps<Props & { variant?: 'dark' | 'brand' | 'light' }>()

defineEmits<{
  resolve: []
}>()

defineSlots<{
  default?: () => any
  close?: () => any
}>()

const sizes = {
  sm: 'width: 25rem;',
  lg: 'width: 32.375rem;'
}

const { $viewport } = useNuxtApp()

const breakpointSize = getValueForBreakpoint($viewport.breakpoint, size)!
const _size = ['sm', 'lg'].includes(breakpointSize) ? breakpointSize : 'lg'
</script>
